import { ClientInfo } from './constants/application';
import { MessageType } from './constants/message-type';
import { Callback } from './models/callback';
import { LOGGER } from './logger';
import { Message } from './models/message';

class CallbackService {
  private static readonly default_message_id = '0';
  private messageHandlers: Record<MessageType, Record<string, Callback>> = {} as any;

  constructor() {
  }

  /**
   * Registers a message handler for Portal messages to the client.
   * - Handler may be for a type/id or just a type.
   * - One handler per (message type && message id) is allowed.
   * - messageId of '0' (default_message_id) is used to represent a generic message type handler.
   *
   * Handler is never removed.
   */
  public registerMessageHandler(type: MessageType, cb: Callback, messageId: string = CallbackService.default_message_id) {
    const typeHandler = this.messageHandlers[type];
    if (!typeHandler) {
      this.messageHandlers[type] = { };
    }
    this.messageHandlers[type][messageId] = cb;
    LOGGER.debug(`Registered handler for '${type}[${messageId}]'`);
  }

  /**
   * Invokes the message handler associated for the MessageType/MessageId and conditionally removes the handler
   */
  public callMessageHandler(message: Message) {
    if (message && message.type) {      
      if (message.portalId === undefined || ClientInfo.PORTAL_ID === undefined || message.portalId === ClientInfo.PORTAL_ID) {

        let msgId = message.id;

        const typeHandler = this.messageHandlers[message.type];

        if (!typeHandler) {
          console.error(`[${ClientInfo.ID}] Handler for '${message.type}' was not found`);
        } else {
          let cb: Callback = typeHandler[msgId];
          if (!cb) {
            msgId = CallbackService.default_message_id;
            cb = typeHandler[msgId];
          }

          if (cb) {
            cb.callbackFn(message);

            if (cb.deleteAfterInvoked) {
              LOGGER.debug(`Removing handler for '${message.type}[${msgId}]'`);
              delete typeHandler[msgId];
            }
          }
        }
      } else {
        LOGGER.debug(`Client's portalId: ${ClientInfo.PORTAL_ID} does not match message's portalId: ${message.portalId}`);
      }
    }
  }
}

export const callbackService = new CallbackService();
